// Thin wrapper around the Web Notifications API for foreground browser push.
// Works while the web app is open in a tab (no service worker / VAPID needed).

export function notifyPermission() {
  if (typeof window === "undefined" || typeof Notification === "undefined")
    return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function requestNotifyPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  try {
    return await Notification.requestPermission();
  } catch {
    return "denied";
  }
}

/**
 * Pop a desktop/browser notification. No-ops unless the user has granted
 * permission. `tag` dedupes repeats for the same logical event.
 */
export function showBrowserNotification({ title, body, tag, onClick }) {
  if (typeof Notification === "undefined" || Notification.permission !== "granted")
    return;
  try {
    const n = new Notification(title || "Notification", {
      body: body || "",
      tag: tag || undefined,
      icon: "/icon-192.png",
      badge: "/icon-192.png",
    });
    if (onClick) {
      n.onclick = () => {
        try {
          window.focus();
        } catch {
          /* noop */
        }
        onClick();
        n.close();
      };
    }
  } catch {
    /* notification construction can throw on some platforms — ignore */
  }
}
